import { createContext, type PropsWithChildren, useState } from 'react'

type LoadingContextType = {
  startLoading: (text: string) => void
  stopLoading: () => void
  isGlobalLoading: boolean
}

export const LoadingContext = createContext<LoadingContextType>({
  startLoading: () => {},
  stopLoading: () => {},
  isGlobalLoading: false
})

const LoadingProvider = ({ children }: PropsWithChildren) => {
  const [isGlobalLoading, setIsGlobalLoading] = useState(false)
  const [loadingText, setLoadingText] = useState('')

  return (
    <LoadingContext.Provider
      value={{
        isGlobalLoading,
        startLoading: (text) => {
          setIsGlobalLoading(true)
          setLoadingText(text ?? '')
        },
        stopLoading: () => {
          setIsGlobalLoading(false)
          setLoadingText('')
        }
      }}
    >
      {children}
      {isGlobalLoading && (
        <div>
          <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center z-50">
            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
          </div>
          <p className="absolute top-32 left-0 w-full h-full flex items-center justify-center z-50">
            {loadingText}
          </p>
        </div>
      )}
    </LoadingContext.Provider>
  )
}

export default LoadingProvider
